var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClass,on:{"click":_vm.onClick}},[_c('div',{staticClass:"reset-button__button"},[_c('span',[_vm._v(" Resetear ")]),_c('svg-icon',{attrs:{"width":"1.25rem","height":"1.25rem","color":"accent-2","name":"fas-redo-alt"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }